var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpSLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 7.21861L4.70013 10.5185L3.75732 9.57567L7.99993 5.33301L12.2426 9.57567L11.2998 10.5185L7.99993 7.21861Z",
    fill: "#FFE700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSLine);
export default __webpack_public_path__ + "static/media/arrow-up-s-line.1d2eb4a11e7cfaad66f617a78b8cc2ce.svg";
export { ForwardRef as ReactComponent };